<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-menu
          v-model="modalDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="filterDateRangeText"
              :label="$t('dash.dateRange')"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="filterDates"
            range
            :locale="$i18n.locale"
            color="primary"
            no-title
          />
        </v-menu>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete
          v-if="isLoginUserSuperAdmin()"
          v-model="organisationId"
          :items="allOrganizations"
          item-text="name"
          item-value="id"
          :label="$t('anOrganization')"
          outlined
          clearable
          :no-data-text="$t('noDataAvailable')"
          :loading="orgLoading"
          :search-input.sync="orgSearch"
          @update:search-input="onOrgSearchInput"
          @click:clear="onOrgClear"
          @focus="onOrgOpen"
          @click="onOrgOpen"
        >
          <template v-slot:item="data">
            <div>
              <div>
                <b>{{ data.item.name }}</b>
              </div>
              <div>
                <span v-if="data.item.street">{{ data.item.street }}</span>
                <span v-if="data.item.postalCode"
                  >, {{ data.item.postalCode }}</span
                >
                <span v-if="data.item.place">, {{ data.item.place }}</span>
                <span v-if="data.item.countryCode"
                  >, {{ data.item.countryCode }}</span
                >
              </div>
            </div>
          </template>
        </v-autocomplete>

        <v-checkbox
          v-if="isLoginUserSuperAdmin()"
          :label="$t('dash.wholeHierarchy')"
          v-model="isSubsidiaries"
          color="primary"
          hide-details
          :disabled="!organisationId"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" md="4" class="d-flex justify-end">
        <v-btn class="btn-one mr-3" height="56px" @click="cancel()">
          <span>{{ $t("cancel") }}</span>
        </v-btn>
        <v-btn class="btn-two" color="#08a657" height="56px" @click="filter()">
          <span>{{ $t("apply") }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DashboardFilter",
  props: [
    "applyFilter",
    "cancelFilter",
    "allOrganizations",
    "dateTimeBegin",
    "dateTimeEnd",
    "selectedOrganizationId",
    "subsidiaries",
    "changeSelectedSubsidiaries",
    "orgLoading",
    "orgSearch",
    "onOrgSearchInput",
    "onOrgClear",
    "onOrgOpen",
  ],

  data() {
    return {
      organisationId: null,
      modalDate: false,
      filterDates: [],
      isSubsidiaries: false,
    };
  },

  computed: {
    localOrgSearch: {
      get() {
        return this.orgSearch;
      },
      set(v) {
        this.onOrgSearchInput(v);
      },
    },
    filterDateRangeText() {
      return this.filterDates.join(" - ");
    },
  },

  methods: {
    filter() {
      if (this.filterDates.length === 2) {
        this.applyFilter(
          this.filterDates[0],
          this.filterDates[1],
          this.organisationId,
          this.isSubsidiaries
        );
      } else {
        this.applyFilter("", "", this.organisationId, this.isSubsidiaries);
      }
    },

    cancel() {
      this.cancelFilter();
    },
    isLoginUserSuperAdmin() {
      return (
        localStorage.getItem("role").toLocaleLowerCase() === "super admin" ||
        localStorage.getItem("role").toLocaleLowerCase() === "super admin plus"
      );
    },
  },

  watch: {
    selectedOrganizationId: {
      handler(v) {
        this.organisationId = v || null;
      },
      immediate: true,
    },
    dateTimeBegin() {
      this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
    },
    dateTimeEnd() {
      this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
    },
    subsidiaries: {
      handler(v) {
        this.isSubsidiaries = v;
      },
      immediate: true,
    },
    isSubsidiaries(v) {
      this.changeSelectedSubsidiaries(v);
    },
  },
  created() {
    this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
    this.organisationId = this.selectedOrganizationId || null;
  },
};
</script>
